import React, { Component } from "react";
import styled from "styled-components";
import Helmet from "react-helmet";
import PostListing from "../components/PostListing/PostListing";
import SEO from "../components/Accessories/SEO";
import config from "../../data/SiteConfig";

class BlogPage extends Component {
  render() {
    const postEdges = this.props.data.allMarkdownRemark.edges;
    return (
      <BlogPageContainer>
        <Helmet title={config.siteTitle} />
        <SEO postEdges={postEdges} />
        <PageBody>
          <PageHead>
            <h1>This is what our engineers and leadership are up to.</h1>
            <h3>
              At AppTree, we are fortunate to get to work cutting edge
              technologies, contribute to open-source and stay active in the
              community. You can learn more about what we are learning and the
              impact we are trying to have in our world by following our blog.
            </h3>
            <Divider />
          </PageHead>
          <PostListing postEdges={postEdges} />
        </PageBody>
      </BlogPageContainer>
    );
  }
}

export default BlogPage;

const BlogPageContainer = styled.div`
  margin: 100px 0;

  @media screen and (max-width: 768px) {
    margin: 50px 0 50px;
  }
`;

const PageHead = styled.div`
  margin: 50px auto;
  text-align: center;
  h1,
  h3 {
    margin: auto;
    margin-bottom: 25px;
  }
  h1 {
    width: 80%;
  }
  h3 {
    width: 85%;
  }
`;

const PageBody = styled.main`
  max-width: 800px;
  margin: auto;
`;

const Divider = styled.div`
  border-bottom: 0.5px solid black;
  width: 60%;
  margin: 50px auto;
`;

/* eslint no-undef: "off"*/
export const pageQuery = graphql`
  query BlogQuery {
    allMarkdownRemark(
      limit: 20
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            type
            title
            tags
            category
            cover
            date
            month
            author
            year
            description
            external
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/blog.jsx